import React from 'react';
import C18Duration00 from '../../usa/components/C18Duration00'
import FUINumerical from './FUINumerical';
import Checkbox from './Checkbox';
import {pInd} from '../../components/utils/paramIds'
import {getParamId,getParamId800,getPearlUsed} from '../../usa/utils/utils';
import {dbVals,putZValue,sendArray} from '../../components/utils/http'
import {HSVtoRGB,makeColor} from '../../usa/components/C18utils'
// import FUISelect from './FUISelect';
// import {proportionals} from '../utilsFui'
import {cl, globs,constant, getTimeI,proportionals,proportionals800} from '../../components/utils/utils';

class HumDeHumFull extends React.Component{
  constructor(props) {
    super(props);
//     cl(props)
    this.state={
      cycleOn:30,
      cycleOff:60,
      dhltTemp:45,
      heatBoost:4.5,
      tempUnit:(["F","C"][props.current.units[0]||0])
//       show: chType!=0
    }
    
    this.loadInfo()
    this.subscribe_savePageEvent=globs.events.subscribe("savePageEvent", this.savePageEvent)
    this.subscribe_updateFui=globs.events.subscribe("updateFui", this.updateFui)
  }
  
  updateFui=()=>{
    if(!this.changed){
      this.setState(this.loadHumStagesData())
    }
  }

  componentWillUnmount=()=>{
    this.subscribe_savePageEvent.remove()
    this.subscribe_updateFui.remove()
  }
  
  savePageEvent=()=>{
    this.saveHumDeHumData()
    this.changed=false
  }

  loadHumStagesData=()=>{
    let pr=this.props
    this.zuci=pr.zuci.split("-")
    let isPearl=pr.current.gwType==1900
    let is800=pr.current.gwType==800
//     humidityOverride = new List<EquipmentType>() - from LinkConn:
//     {
//         EQ_VENT, EQ_CURT, EQ_ONOFF, EQ_PUMP, EQ_HID, EQ_CO2, EQ_MZONE, EQ_MZONE2, EQ_MIXV, EQ_MIXV_A,
//     };
    let eqVent=constant.EQ_VENT
    let eqCurt=constant.EQ_CURT
    let eqOnOff=constant.EQ_ONOFF
    if(is800){
      eqVent=constant.EQ_800_VENT
      eqCurt=constant.EQ_800_CURTAIN
      eqOnOff=constant.EQ_800_ON_OFF
    }

    this.hums=[eqVent, eqCurt, eqOnOff, constant.EQ_PUMP, constant.EQ_HID, constant.EQ_CO2, constant.EQ_MZONE, constant.EQ_MZONE2, constant.EQ_MIXV, constant.EQ_MIXV_AN]
//     this.proportionals=[constant.EQ_VENT, constant.EQ_CURT, constant.EQ_MIXV,
//       constant.EQ_MZONE2, ,constant.EQ_GEN_PID, constant.EQ_VAROUT, constant.EQ_MIXV_AN]
    this.dehumInfo={
      cycleOn:"Humidity Override On Time",
      cycleOff:"Humidity Override Off Time",
      humCycleOn:"hdh_h_on",
      humCycleOff:"hdh_h_off",
      dhltTemp:"Dehumidify Low Outside Temperature Threshold",
      heatBoost:"Dehumidify Heat Boost",
      fzEnable:"hdh_fuzzy_enable",
      fzFrom:"hdh_fuzzy_from",
      fzTo:"hdh_fuzzy_to",
    }
    let defaults={
      cycleOn:30,
      cycleOff:30,
      humCycleOn:30,
      humCycleOff:30,
      fzEnable:0,
      fzFrom:0,
      fzTo:0,
      dhltTemp:40,
      heatBoost:5,
    }
    this.zuci=pr.zuci.split("-")
    let ci=pr.current.channelInfo
    // cl(pr)
    this.chans={}
//     cl(this.hums)
    let i2=1
    var pearlUsed=[],chans=[]
    let zInd=+this.zuci[0]
    if(isPearl){
      pearlUsed=getPearlUsed(zInd)
      chans=Object.keys(pearlUsed).map(k=>{return pearlUsed[k].chInd})
    }
    if(is800){
      chans=[...Array(8).keys()]
    }
//     cl(pearlUsed)
    ci.forEach((ch,i)=>{
//       cl(ch)
//       cl(ch.channelType)
//       cl([1,2,3].includes(ch.channelType))
//       cl(this.hums.includes(ch.channelType))
//       cl(pr.current.gwType)
      if(isPearl||is800){
        if(chans.includes(i)){
//           cl(ch)
          ch.chId=i+1
          if(!ch.channelName){ch.channelName="None"}
          let show=this.hums.includes(+ch.channelType)
          // show&&=(is800&&proportionals800.includes(ch.channelType)&&(i%2))
          show=show&&!(is800&&proportionals800.includes(ch.channelType)&&(i%2))
          if(show){this.chans[i]=ch}
        }
      }else{
        if(ch.used||(pr.current.gwType==1900)){ch.chId=i2++}
        if(this.hums.includes(+ch.channelType) ){this.chans[i]=ch}
      }
    })
    let hdhSettings=this.getSaveHDH("get")
    let z=this.zuci[0]
    let vals={}
    Object.keys(this.dehumInfo).forEach(k=>{
      let tab="configuration_zone_settings"
      let ch=255
      if(["humCycleOn","humCycleOff","fzEnable","fzFrom","fzTo",

      ].includes(k)){
        tab="pearl_config"
        ch=240
      }
      let v=dbVals.z[z][ch][getParamId(tab,this.dehumInfo[k])]
      if((v==undefined)||(v==null)){v=defaults[k]}
      vals[k]=v
    })
//     cl(vals)
    vals.hdhSettings=hdhSettings
    return vals
  }

  loadInfo=()=>{
//     cl(hdhSettings)
    let vals=this.loadHumStagesData()
    Object.assign(this.state,vals)
//     this.state.hdhSettings=hdhSettings
  }
  
//http://ngsg.link4cloud.com:3104/usa/c18/fui/HumDeHum/1-0-240-0
  
  onChange=(type,vals)=>{
//     cl(type,vals)
    let st=this.state
    if(!this.props.groupFwBlocked){globs.events.publish("savePageEnable",true)}
    if(this.props.groupFwBlocked){globs.events.publish("savePageEnable",false)}
    switch(type){
      case "upd":
        this.changed=true
        this.setState(vals)
        break
      case "hum":
//         cl(vals)
        let hs=Object.assign({},st.hdhSettings)
        let v=vals.val
//         cl(vals)
        hs[vals.ch][vals.humStage]=(v.length>0)?+v:v
        this.changed=true
        this.setState({hdhSettings:hs})
        break
      default:
        break
    }
    
  }
  
  saveGlobalHdh=(z,hdhDBSettings)=>{
    let st=this.state
    Object.keys(this.dehumInfo).forEach(k=>{
      let tab="configuration_zone_settings"
      let ch=255
      if(["humCycleOn","humCycleOff","fzEnable","fzFrom","fzTo",].includes(k)){
        // C20C22-4087: these pearl_config params only exist on Pearl fw >= 1.18.2 (UI hides them below that).
        // Sending them to older fw makes the backend verify/retry loop fail -> false "Error - Not Saved!"
        if(!this.props.fwFlags?.isPearl182){return}
        // C20C22-4621: fuzzy params are only supported above Pearl fw 1.18.2 (hidden in the UI on 1.18.2 and older)
        if(["fzEnable","fzFrom","fzTo"].includes(k)&&!this.props.fwFlags?.isPearlFuzzy){return}
        tab="pearl_config"
        ch=240
      }

      let pid=getParamId(tab,this.dehumInfo[k])
      if (putZValue(z,ch,pid,st[k])){// was hard-coded 255, wrong for the ch 240 params
        hdhDBSettings.push({
          c:ch,// zone wide
          d:st[k],
          f:1,
          i:pid,
          t:getTimeI(),
          z:z,
        })
      }
    })
  }
  
  getSaveHDH=(getSave)=>{
// 0, 1, "0", and "1" are valid values for the stage override
// the "none" or null condition is represented by -1
    let st=this.state
    let z=this.zuci[0]
    // let tab=pInd[1800].channels_configuration
    let hdhSettings={}// used for both get and save
    let fields=["stageDehumidfy1","stageDehumidfy2","stageColdDehumidfy","stageHumidfy"]
    let tab="configuration_channels"
    let current=this.props.current
    let is800=current.gwType==800
    // let res=getParamId800("igCE","humidify")
    // cl(res)
    if(is800){
      tab="igCE"
      fields=["humidify","dehumidify","coldDehum"]
    }
    if(getSave=="get"){
      Object.keys(this.chans).forEach(k=>{
        let ch=dbVals.z[z][k]
        hdhSettings[k]=fields.map(f=>{
          let v=ch[((is800)?getParamId800:getParamId)(tab,f)]
          if(((typeof v=="string")&&(v.length==0))||(v==null)){return ""}
          return +v
        })
      })
      return hdhSettings
    }else{
      let now=getTimeI()
      let hdhDBSettings=[]
      Object.keys(this.chans).forEach(k=>{
        let ch=dbVals.z[z][k]
        fields.forEach((f,i)=>{
          let pid=((is800)?getParamId800:getParamId)(tab,f)
          let v=st.hdhSettings[k][i]
          if(is800&&(v==="")){v=-1}
//           if((typeof v=="string")&&(v.length==0)){v=null}
//           cl(v)
//           if(v!=null){v=+v}
//           if(v.length==0)
          if (putZValue(z,k,pid,v)){
            hdhDBSettings.push({
              c:+k,// zone wide
              d:v,//st.hdhSettings[k][i],
              f:1,
              i:pid,
              t:now,
              z:z,
            })
          }
        })
      })
      if(!is800){this.saveGlobalHdh(z,hdhDBSettings)}
      // cl(hdhDBSettings)
      sendArray(hdhDBSettings,this.props.current.virtual,
        current.gwType,current.controllerId
      ).then(e=>{globs.events.publish("saveOK",true)})
    }
    
  }
  
  saveHumDeHumData=()=>{
    this.getSaveHDH("save")
    
  }
  
  showHDHSelect=(ch,humStage)=>{// ch is the channel index
//     cl(ch)
    let st=this.state
    let ci=this.chans[ch]
    // cl(ci)
    let val=st.hdhSettings[ch][humStage]
    // cl(val)
    if((typeof val=="string")&&(val.length==0)){val=-1}
    var color
    var opts
//     if(ch==6){cl(ci)}
    let arr=(this.props.current.gwType==800)?proportionals800:proportionals
    if(arr.includes(+ci.channelType)){
//       cl(val)
      color=(val==-1)?"#EEFFFF":color=makeColor(0,0.3,val/100,0.4,1)
//       if(val==-1){
//         color=
//       }else{
//         color=makeColor(0,0.3,val/100,0.4,1)
//       }
      opts=[-1,...Array(100).keys()].map(k=>{
        let show=(k>=0)?`${k}%`:"---"
        return(
          <option key={k} value={k}>{show}</option>
        )
      })
    }else{
      color=["#EEFFFF","#EEAAAA","#EEEE88"][+val+1]
      opts=[
        <option key="1" value="-1">---</option>,
        <option key="2" value="0">Off</option>,
        <option key="3" value="1">On</option>
      ]
    }
    return(
      <td key={humStage}>
        <select
        style={{padding: 10,borderRadius:10,backgroundColor:color}}
          value={val}
          onChange={e=>this.onChange("hum",{ch:ch,humStage:humStage,val:e.target.value})}
        >
        {opts}
        </select>
      </td>
    )
  }
  
  showHDHHeads=()=>{
    let heads=["Chan","Name","DeHum1","DeHum2","DeHumLT","Hum"]
    if(this.props.current.gwType==800){
      heads=["Chan","Name","DeHum","DeHumLT","Hum"]
    }
    return (
      <tr key="heads">
      {heads.map((h,i)=>{return <th key={i}><h3>{h}</h3></th>})}
      </tr>
    )
//     return(
//       <tr>
//       <th>Chan</th>
//       <th>Name</th>
//       <th>DeHum1</th>
//       <th>DeHum2</th>
//       <th>DeHumLT</th>
//       <th>Hum</th>
//       </tr>
//     )
  }
  
  showChannels=()=>{
    let pr=this.props
    let ci=pr.current.channelInfo
    // cl(this.chans)
//     cl(this.chans)
    let rows=Object.keys(this.chans).map(k=>{
      let ch=this.chans[k]
//       cl(Array(4))
//       cl(Array(4).keys())
//       cl([...Array(4).keys()])
//       let hdhRow=Array(4).keys().map(humS=>{
      let humStages=(pr.current.gwType==800)?3:4
      let hdhRow=[...Array(humStages).keys()].map(humS=>{
        return this.showHDHSelect(k,humS)
      })
      return <tr key={k}><td height="49">{ch.chId}</td><td>{ch.channelName}</td>{hdhRow}</tr>
    })
    return(
      <div>
      <table><tbody>
      {this.showHDHHeads()}
      {rows}
      </tbody></table>
      </div>
    )
  }

  checkNumIndexes=["fzEnable","fzFrom","fzTo"]

  getValue=(ind,val)=>{
    let st=this.state
//     cl(this.checkNumIndexes[ind])
//     cl(st[this.checkNumIndexes[ind]])
    return st[this.checkNumIndexes[ind]]||""
  }

  numChange=(ind,val)=>{
    if(!this.props.groupFwBlocked){globs.events.publish("savePageEnable",true)}
    if(this.props.groupFwBlocked){globs.events.publish("savePageEnable",false)}
    this.changed=true
    cl(ind,val)
    let stVal={}
    stVal[this.checkNumIndexes[ind]]=val.value
    cl(stVal)
    this.setState(stVal)
  }

  showGlobalSettings=()=>{
    let st=this.state
//     cl(st.fzTo)
    let unit=<span style={{cursor:"default",marginLeft:-60}}>&deg;{st.tempUnit}</span>
    let pr=this.props
    if(pr.current.gwType==800){return}
    let dhLab=(pr.fwFlags.isPearl182)?"Dehum":"Hum/Dehum"
    return(
      <table><tbody>
      <tr>
      <td>
        <label>{dhLab} Cycle On Time</label>
        <C18Duration00 parms={{
        width:100,
        duration:st.cycleOn,
        onChange:e=>this.onChange("upd",{cycleOn:e.duration}),
        saveOK:true,//this.props.parms.saveOK
        unit:"(MM:SS)",
        }}/>
      </td>
      <td>
        <label>{dhLab} Cycle Off Time</label>
        <C18Duration00 parms={{
        width:110,
        duration:st.cycleOff,
        onChange:e=>this.onChange("upd",{cycleOff:e.duration}),
        saveOK:true,//this.props.parms.saveOK
        unit:"(MM:SS)",
        }}/>
      </td>
      </tr>
      {pr.fwFlags.isPearl182&&
        <>
          <tr><td height="10"></td><td></td></tr>
          <tr>
          <td>
            <label>Hum Cycle On Time</label>
            <C18Duration00 parms={{
            width:100,
            duration:st.humCycleOn,
            onChange:e=>this.onChange("upd",{humCycleOn:e.duration}),
            saveOK:true,//this.props.parms.saveOK
            unit:"(MM:SS)",
            }}/>
          </td>
          <td>
            <label>Hum Cycle Off Time</label>
            <C18Duration00 parms={{
            width:110,
            duration:st.humCycleOff,
            onChange:e=>this.onChange("upd",{humCycleOff:e.duration}),
            saveOK:true,//this.props.parms.saveOK
            unit:"(MM:SS)",
            }}/>
          </td>
          </tr>
        </>
      }
      <tr><td height="10"></td><td></td></tr>
      {pr.fwFlags.isPearlFuzzy&&
        <>
          <tr><td height="20"></td><td></td></tr>
          <tr>
          <td>
            <Checkbox
              getValue={this.getValue}
              onChange={this.numChange}
              custom={{oneBit:1}}
              value={st.fzEnable}
              ind={0}
              title="Fuzzy Enable"
              saveOK={true}
              cont={{ pid: 55 }} />
          </td>
          <td>
          </td>
          </tr>
          <tr>
          <td>
            <FUINumerical
            getValue={this.getValue}
            onChange={this.numChange}
            custom={{"width":100,"decimal":0,"step":1,"unit":"%"}}
            value={st.fzFrom??""}
            ind={1}
            cont={{title:"Ramp From",pid:44}}
            saveOK={true}
            style={{ width: "60px", minWidth: "60px", maxWidth: "80px" }}
            />
          </td>
          <td>
            <FUINumerical
            getValue={this.getValue}
            onChange={this.numChange}
            custom={{"width":100,"decimal":0,"step":1,"unit":"%"}}
            value={st.fzTo??""}
            ind={2}
            cont={{title:"Ramp To"}}
            saveOK={true}
            style={{ width: "60px", minWidth: "60px", maxWidth: "80px" }}
            />
          </td>
          </tr>
        </>
      }
      <tr>
      <td>
        <label>Use DHLT when outside temperature goes below</label>
        <input
          style={{width:100}}
          type="number"
          value={st.dhltTemp}
          onChange={e=>this.onChange("upd",{dhltTemp:e.currentTarget.value})}
          min="0"
          max="80"
          step="0.1"
        />{unit}
      </td>
      <td>
        <label>When any DeHum stage is active, adjust temp setpoint (Heat Boost) by:</label>
        <input
          style={{width:100}}
          type="number"
          value={st.heatBoost}
          onChange={e=>this.onChange("upd",{heatBoost:e.currentTarget.value})}
          min="-10"
          max="10"
          step="0.1"
        />{unit}
      </td>
      </tr>
      </tbody></table>

    )
  }
  
  render(){
    return(
      <div>
      <div style={{overflowX:"auto"}}>
      <div className="clearfloat"/><br/>
      <h2>Hum and DeHum Stage Overrides:</h2>
      {this.showChannels()}
      {this.showGlobalSettings()}
      </div>
      </div>
    )
  }
}

export default HumDeHumFull ;
